<script>
    import {PATH_PREFIX} from '../../../../apiUrls.js';
    export let row = null;
</script>

{#if row.has_access}
<a href={`${PATH_PREFIX}/sw/elements_database/${row.element.id}/`} target="_blank" rel="noopener noreferrer">
    {row.element_version.name}
</a>

{:else}
    {row.element_version.name}
{/if}

